<template>
  <q-page padding>
    <!-- Título e filtro de unidade -->

    <PageHeader
      title="Gestão de Riscos"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />

    <div class="row q-mb-lg">
      <div class="col-12 col-md-3">
        <div class="text-caption text-weight-bold text-brand-5 q-mb-xs">
          Unidade
        </div>
        <ListaUnidadesSelect />
      </div>
    </div>

    <!-- Tabs -->
    <q-tabs
      v-model="tab"
      dense
      class="text-grey q-mt-sm"
      active-color="primary"
      indicator-color="primary"
      align="justify"
      narrow-indicator
    >
      <q-tab name="riscos" icon="warning" label="Riscos" />
      <q-tab name="vinculos" icon="link" label="Riscos vs CAs" />
    </q-tabs>

    <q-separator />

    <q-tab-panels v-model="tab" animated class="q-pa-none">
      <q-tab-panel name="riscos" class="q-pa-none q-pt-md">
        <!-- Aba Riscos -->
        <div class="q-pa-md bg-white rounded-borders shadow-1">
          <div class="row items-center justify-between q-mb-md">
            <span class="text-h6 text-weight-bold" style="color: #21324a">
              Todos os Riscos Cadastrados
            </span>
            <div class="row q-gutter-sm items-center">
              <q-input
                v-model="buscaRiscos"
                dense
                outlined
                placeholder="Pesquisar"
                style="min-width: 200px"
                @update:model-value="debounceBuscaRiscos"
              >
                <template v-slot:prepend>
                  <q-icon name="search" size="sm" />
                </template>
              </q-input>
              <q-btn
                no-caps
                unelevated
                icon="add"
                label="Vincular Risco vs CA"
                style="
                  background-color: #21324a;
                  color: white;
                  border-radius: 8px;
                "
                @click="abrirModalVincular"
              />
              <q-btn
                no-caps
                unelevated
                icon="add"
                label="Criar Risco"
                style="
                  background-color: #1a73e8;
                  color: white;
                  border-radius: 8px;
                "
                @click="abrirModalCriar"
              />
            </div>
          </div>

          <q-table
            flat
            :rows="riscos"
            :columns="colunasRiscos"
            :loading="carregandoRiscos"
            :pagination="{ rowsPerPage: 0 }"
            row-key="id"
            hide-pagination
          >
            <template #header="props">
              <q-tr :props="props" style="background-color: #f0f4f8">
                <q-th
                  v-for="col in props.cols"
                  :key="col.name"
                  :props="props"
                  class="text-weight-bold text-brand-5"
                  style="font-size: 13px"
                >
                  {{ col.label }}
                </q-th>
              </q-tr>
            </template>

            <template v-slot:no-data>
              <div
                class="full-width row flex-center q-gutter-sm q-pa-md text-grey-6"
              >
                Nenhum risco encontrado
              </div>
            </template>

            <template #body-cell-code="props">
              <q-td :props="props">
                <q-input
                  v-if="linhaEditando === props.row.id"
                  v-model="edicao.code"
                  dense
                  outlined
                  hide-bottom-space
                  style="min-width: 90px"
                />
                <span v-else>{{ props.value }}</span>
              </q-td>
            </template>

            <template #body-cell-name="props">
              <q-td :props="props">
                <q-input
                  v-if="linhaEditando === props.row.id"
                  v-model="edicao.name"
                  dense
                  outlined
                  hide-bottom-space
                  style="min-width: 160px"
                />
                <span v-else>{{ props.value }}</span>
              </q-td>
            </template>

            <template #body-cell-createdAt="props">
              <q-td :props="props">
                {{ formatarData(props.value) }}
              </q-td>
            </template>

            <template #body-cell-updatedAt="props">
              <q-td :props="props">
                {{ formatarData(props.value) }}
              </q-td>
            </template>

            <template #body-cell-historico="props">
              <q-td :props="props" class="text-center">
                <q-btn
                  flat
                  round
                  dense
                  color="teal"
                  icon="history"
                  :disable="linhaEditando !== null"
                  @click="abrirHistorico(props.row)"
                >
                  <q-tooltip>Ver Histórico</q-tooltip>
                </q-btn>
              </q-td>
            </template>

            <template #body-cell-editar="props">
              <q-td :props="props" class="text-center">
                <template v-if="linhaEditando === props.row.id">
                  <q-btn
                    flat
                    round
                    dense
                    color="positive"
                    icon="check"
                    :loading="salvandoEdicao"
                    @click="salvarEdicao(props.row)"
                  >
                    <q-tooltip>Salvar Edição</q-tooltip>
                  </q-btn>
                  <q-btn
                    flat
                    round
                    dense
                    color="negative"
                    icon="close"
                    @click="cancelarEdicao"
                  >
                    <q-tooltip>Cancelar Edição</q-tooltip>
                  </q-btn>
                </template>
                <q-btn
                  v-else
                  flat
                  round
                  dense
                  color="primary"
                  icon="edit"
                  @click="iniciarEdicao(props.row)"
                >
                  <q-tooltip>Editar Risco</q-tooltip>
                </q-btn>
              </q-td>
            </template>

            <template #body-cell-deletar="props">
              <q-td :props="props" class="text-center">
                <q-btn
                  flat
                  round
                  dense
                  color="negative"
                  icon="delete"
                  :disable="linhaEditando !== null"
                  @click="confirmarDelecao(props.row)"
                >
                  <q-tooltip>Excluir Risco</q-tooltip>
                </q-btn>
              </q-td>
            </template>
          </q-table>

          <div v-if="totalRiscos > 0" class="row justify-center q-mt-md">
            <q-pagination
              v-model="paginaRiscos"
              :max="totalPaginasRiscos"
              :max-pages="5"
              :boundary-numbers="false"
              :direction-links="true"
              color="brand-5"
              active-color="primary"
              active-text-color="white"
              size="sm"
              @update:model-value="carregarRiscos"
            />
          </div>
        </div>
      </q-tab-panel>

      <q-tab-panel name="vinculos" class="q-pa-none q-pt-md">
        <!-- Aba Riscos vs CAs -->
        <div class="q-pa-md bg-white rounded-borders shadow-1">
          <div class="row items-center justify-between q-mb-md">
            <span class="text-h6 text-weight-bold" style="color: #21324a">
              Riscos Vinculados aos CAs
            </span>
            <q-input
              v-model="buscaVinculos"
              dense
              outlined
              placeholder="Pesquisar"
              style="min-width: 200px"
              @update:model-value="debounceBuscaVinculos"
            >
              <template v-slot:prepend>
                <q-icon name="search" size="sm" />
              </template>
            </q-input>
          </div>

          <q-table
            flat
            :rows="vinculos"
            :columns="colunasVinculos"
            :loading="carregandoVinculos"
            :pagination="{ rowsPerPage: 0 }"
            row-key="id"
            hide-pagination
          >
            <template #header="props">
              <q-tr :props="props" style="background-color: #f0f4f8">
                <q-th
                  v-for="col in props.cols"
                  :key="col.name"
                  :props="props"
                  class="text-weight-bold text-brand-5"
                  style="font-size: 13px"
                >
                  {{ col.label }}
                </q-th>
              </q-tr>
            </template>

            <template v-slot:no-data>
              <div
                class="full-width row flex-center q-gutter-sm q-pa-md text-grey-6"
              >
                Nenhum vínculo encontrado
              </div>
            </template>

            <template #body-cell-created_at="props">
              <q-td :props="props">
                {{ formatarData(props.value) }}
              </q-td>
            </template>

            <template #body-cell-updated_at="props">
              <q-td :props="props">
                {{ formatarData(props.value) }}
              </q-td>
            </template>

            <template #body-cell-ca_validity="props">
              <q-td :props="props">
                {{
                  formatarData(props.row.riskControl?.linkedEntity?.expiresIn)
                }}
              </q-td>
            </template>

            <template #body-cell-ca_code="props">
              <q-td :props="props">
                {{ props.row.riskControl?.linkedEntity?.code ?? "-" }}
              </q-td>
            </template>

            <template #body-cell-vendor="props">
              <q-td :props="props">
                {{ props.row.risk?.vendor?.name ?? "-" }}
              </q-td>
            </template>

            <template #body-cell-acao="props">
              <q-td :props="props">
                <q-btn
                  no-caps
                  unelevated
                  icon="visibility"
                  label="Consultar Produtos"
                  style="
                    background-color: #1a73e8;
                    color: white;
                    border-radius: 5px;
                    font-size: 13px;
                  "
                  @click="consultarProdutos(props.row)"
                />
              </q-td>
            </template>
          </q-table>

          <div v-if="totalVinculos > 0" class="row justify-center q-mt-md">
            <q-pagination
              v-model="paginaVinculos"
              :max="totalPaginasVinculos"
              :max-pages="5"
              :boundary-numbers="false"
              :direction-links="true"
              color="brand-5"
              active-color="primary"
              active-text-color="white"
              size="sm"
              @update:model-value="carregarVinculos"
            />
          </div>
        </div>
      </q-tab-panel>
    </q-tab-panels>

    <!-- Modal Criar Risco -->
    <ModalCriarRisco
      v-model="showModalCriar"
      :vendor-id="unidadeSelecionada?.id"
      @risco-criado="carregarRiscos"
    />

    <!-- Modal Vincular Risco ao CA -->
    <ModalVincularRiscoCA
      v-model="showModalVincular"
      :vendor-id="unidadeSelecionada?.id"
      @vinculos-criados="carregarVinculos"
    />

    <!-- Dialog confirmação de exclusão -->
    <DialogConfirmDesign
      titulo="Excluir Risco"
      mensagem="Tem certeza que deseja excluir este risco?"
      :exibir="showConfirmDelete"
      @resultado="executarDelecao"
    />

    <!-- Modal Histórico do Risco -->
    <q-dialog
      v-model="showModalHistorico"
      transition-show="scale"
      transition-hide="scale"
    >
      <q-card style="width: 1200px; max-width: 95vw">
        <div class="bg-brand-1 text-white">
          <q-card-section class="row items-center justify-between">
            <div class="text-h6">Histórico do Risco</div>
            <q-btn icon="close" flat round dense v-close-popup />
          </q-card-section>
        </div>
        <q-card-section class="q-pa-none">
          <q-table
            flat
            :rows="historicoRisco"
            :columns="colunasHistorico"
            :loading="carregandoHistorico"
            :pagination="{ rowsPerPage: 0 }"
            row-key="id"
            hide-pagination
          >
            <template #header="props">
              <q-tr :props="props" style="background-color: #f0f4f8">
                <q-th
                  v-for="col in props.cols"
                  :key="col.name"
                  :props="props"
                  class="text-weight-bold text-brand-5"
                  style="font-size: 13px"
                >
                  {{ col.label }}
                </q-th>
              </q-tr>
            </template>

            <template v-slot:no-data>
              <div class="full-width row flex-center q-pa-md text-grey-6">
                Nenhum histórico encontrado
              </div>
            </template>

            <template #body-cell-createdAt="props">
              <q-td :props="props">
                {{ formatarData(props.value) }}
              </q-td>
            </template>
          </q-table>
        </q-card-section>
      </q-card>
    </q-dialog>

    <!-- Modal Produtos do CA -->
    <q-dialog
      v-model="showModalProdutos"
      transition-show="scale"
      transition-hide="scale"
    >
      <q-card style="width: 1100px; max-width: 95vw">
        <div class="bg-brand-1 text-white">
          <q-card-section class="row items-center justify-between">
            <div class="text-h6">{{ tituloModalProdutos }}</div>
            <q-btn icon="close" flat round dense v-close-popup />
          </q-card-section>
        </div>
        <q-card-section class="q-pa-none">
          <q-table
            flat
            :rows="produtosCA"
            :columns="colunasProdutos"
            :loading="carregandoModalProdutos"
            :pagination="{ rowsPerPage: 0 }"
            row-key="id"
            hide-pagination
          >
            <template #header="props">
              <q-tr :props="props" style="background-color: #f0f4f8">
                <q-th
                  v-for="col in props.cols"
                  :key="col.name"
                  :props="props"
                  class="text-weight-bold text-brand-5"
                  style="font-size: 13px"
                >
                  {{ col.label }}
                </q-th>
              </q-tr>
            </template>

            <template v-slot:no-data>
              <div class="full-width row flex-center q-pa-md text-grey-6">
                Nenhum produto encontrado
              </div>
            </template>

            <template #body-cell-validade="props">
              <q-td :props="props">
                {{ formatarData(props.row.pivot?.ca?.expires_in) }}
              </q-td>
            </template>

            <template #body-cell-status_ca="props">
              <q-td :props="props">
                <div class="row justify-center">
                  <div
                    v-if="props.row.pivot?.ca?.status ?? props.row.ca?.status"
                    class="row items-center"
                    :style="
                      (props.row.pivot?.ca?.status ?? props.row.ca?.status) ===
                      'Válido'
                        ? 'width: fit-content; background: #e8ffec; padding: 2px 6px; border-radius: 4px;'
                        : 'width: fit-content; background: #ffe9e9; padding: 2px 6px; border-radius: 4px;'
                    "
                  >
                    <span
                      :style="
                        (props.row.pivot?.ca?.status ??
                          props.row.ca?.status) === 'Válido'
                          ? 'width: 8px; height: 8px; border-radius: 50%; background: #2eae60; margin-right: 6px; display: inline-block;'
                          : 'width: 8px; height: 8px; border-radius: 50%; background: #d32f2f; margin-right: 6px; display: inline-block;'
                      "
                    />
                    <span
                      :style="
                        (props.row.pivot?.ca?.status ??
                          props.row.ca?.status) === 'Válido'
                          ? 'font-weight: 600; color: #1f2937;'
                          : 'font-weight: 600; color: #850202;'
                      "
                    >
                      {{ props.row.pivot?.ca?.status ?? props.row.ca?.status }}
                    </span>
                  </div>
                  <span v-else>-</span>
                </div>
              </q-td>
            </template>
          </q-table>
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
const colunasRiscos = [
  { name: "id", label: "ID", field: "id", align: "left" },
  { name: "code", label: "Código", field: "code", align: "left" },
  { name: "name", label: "Nome", field: "name", align: "left" },
  {
    name: "createdAt",
    label: "Data Criação",
    field: "createdAt",
    align: "center",
  },
  {
    name: "updatedAt",
    label: "Data Atualização",
    field: "updatedAt",
    align: "center",
  },
  {
    name: "historico",
    label: "Histórico",
    field: (row) => row,
    align: "center",
  },
  { name: "editar", label: "Editar", field: (row) => row, align: "center" },
  { name: "deletar", label: "Deletar", field: (row) => row, align: "center" },
];

const colunasVinculos = [
  {
    name: "vendor",
    label: "Unidade",
    field: (row) => row.risk?.vendor?.name ?? "-",
    align: "left",
  },
  {
    name: "code",
    label: "Cód. Risco",
    field: (row) => row.risk?.code ?? "-",
    align: "left",
  },
  {
    name: "name",
    label: "Nome do Risco",
    field: (row) => row.risk?.name ?? "-",
    align: "left",
  },
  {
    name: "created_at",
    label: "Data Criação",
    field: (row) => row.risk?.createdAt ?? "-",
    align: "center",
  },
  {
    name: "updated_at",
    label: "Data Atualização",
    field: (row) => row.risk?.updatedAt ?? "-",
    align: "center",
  },
  {
    name: "ca_code",
    label: "Cód. CA",
    field: (row) => row.riskControl?.linkedEntity?.code ?? "-",
    align: "center",
  },
  {
    name: "ca_validity",
    label: "Validade CA",
    field: (row) => row.riskControl?.linkedEntity?.expiresIn ?? "-",
    align: "center",
  },
  { name: "acao", label: "Ação", field: (row) => row, align: "center" },
];

const colunasHistorico = [
  { name: "id", label: "ID", field: "id", align: "left" },
  {
    name: "code",
    label: "Código",
    field: (row) => row.version?.code ?? "-",
    align: "left",
  },
  {
    name: "name",
    label: "Nome",
    field: (row) => row.version?.name ?? "-",
    align: "left",
  },
  {
    name: "user",
    label: "Usuário",
    field: (row) => row.user?.name ?? "-",
    align: "left",
  },
  {
    name: "action",
    label: "Ação",
    field: (row) => row.actionName ?? "-",
    align: "center",
  },
  { name: "createdAt", label: "Data", field: "createdAt", align: "center" },
];

const colunasProdutos = [
  { name: "code", label: "Código", field: "code", align: "left" },
  {
    name: "description",
    label: "Descrição",
    field: (row) => row.description || row.name || "-",
    align: "left",
  },
  {
    name: "ca",
    label: "CA",
    field: (row) => row.pivot?.ca?.code ?? "-",
    align: "center",
  },
  {
    name: "validade",
    label: "Validade",
    field: (row) => row.pivot?.ca?.expires_in ?? "-",
    align: "center",
  },
  {
    name: "status_ca",
    label: "Status do CA",
    field: (row) => row.pivot?.ca?.status ?? row.ca?.status ?? "-",
    align: "center",
  },
];

import { ref, computed, watch, onMounted } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import ModalCriarRisco from "../components/ModalCriarRisco.vue";
import ModalVincularRiscoCA from "../components/ModalVincularRiscoCA.vue";
import DialogConfirmDesign from "../../../components/DialogConfirmDesign.vue";
import PageHeader from "../../../components/PageHeader.vue";

export default {
  components: {
    ListaUnidadesSelect,
    ModalCriarRisco,
    ModalVincularRiscoCA,
    DialogConfirmDesign,
    PageHeader,
  },
  setup() {
    const store = useStore();
    const quasar = useQuasar();

    const tab = ref("riscos");
    const unidadeSelecionada = computed(
      () => store.state.org.unidadeData || null
    );

    // Riscos
    const riscos = ref([]);
    const carregandoRiscos = ref(false);
    const buscaRiscos = ref("");
    const paginaRiscos = ref(1);
    const totalRiscos = ref(0);
    const porPaginaRiscos = 10;
    let timerBuscaRiscos = null;

    // Vínculos
    const vinculos = ref([]);
    const carregandoVinculos = ref(false);
    const buscaVinculos = ref("");
    const paginaVinculos = ref(1);
    const totalVinculos = ref(0);
    const porPaginaVinculos = 10;
    let timerBuscaVinculos = null;

    // Modais
    const showModalCriar = ref(false);
    const showModalVincular = ref(false);
    const showConfirmDelete = ref(false);
    const riscoParaDeletar = ref(null);

    // Histórico
    const showModalHistorico = ref(false);
    const historicoRisco = ref([]);
    const carregandoHistorico = ref(false);

    // Produtos do CA
    const showModalProdutos = ref(false);
    const produtosCA = ref([]);
    const carregandoModalProdutos = ref(false);
    const tituloModalProdutos = ref("");

    const totalPaginasRiscos = ref(1);
    const totalPaginasVinculos = ref(1);

    // Edição inline
    const linhaEditando = ref(null);
    const edicao = ref({ code: "", name: "" });
    const salvandoEdicao = ref(false);

    const iniciarEdicao = (row) => {
      linhaEditando.value = row.id;
      edicao.value = { code: row.code, name: row.name };
    };

    const cancelarEdicao = () => {
      linhaEditando.value = null;
      edicao.value = { code: "", name: "" };
    };

    const salvarEdicao = async (row) => {
      salvandoEdicao.value = true;
      try {
        await store.dispatch("gestaoDeRiscos/editarRisco", {
          id: row.id,
          name: edicao.value.name,
          code: edicao.value.code,
          vendorId: unidadeSelecionada.value.id,
        });
        quasar.notify({
          message: "Risco atualizado com sucesso!",
          color: "positive",
          position: "bottom",
          icon: "check_circle",
        });
        cancelarEdicao();
        carregarRiscos();
      } catch (err) {
        const mensagem =
          err?.response?.data?.message ?? "Erro ao atualizar risco.";
        quasar.notify({
          message: mensagem,
          color: "negative",
          position: "bottom",
        });
      } finally {
        salvandoEdicao.value = false;
      }
    };

    const formatarData = (data) => {
      if (!data) return "-";
      try {
        const soData = String(data).substring(0, 10);
        const [ano, mes, dia] = soData.split("-");
        return `${dia}/${mes}/${ano}`;
      } catch {
        return data;
      }
    };

    const carregarRiscos = async (pagina = paginaRiscos.value) => {
      if (!unidadeSelecionada.value?.id) return;
      carregandoRiscos.value = true;
      try {
        if (buscaRiscos.value) {
          const busca = buscaRiscos.value;
          const [byName, byCode] = await Promise.all([
            store.dispatch("gestaoDeRiscos/listarRiscos", {
              vendorId: unidadeSelecionada.value.id,
              page: 1,
              perPage: 100,
              name: busca,
            }),
            store.dispatch("gestaoDeRiscos/listarRiscos", {
              vendorId: unidadeSelecionada.value.id,
              page: 1,
              perPage: 100,
              code: busca,
            }),
          ]);
          const nameData = byName.data?.result?.data ?? [];
          const codeData = byCode.data?.result?.data ?? [];
          const seen = new Set();
          riscos.value = [...nameData, ...codeData].filter((r) => {
            if (seen.has(r.id)) return false;
            seen.add(r.id);
            return true;
          });
          totalRiscos.value = riscos.value.length;
          paginaRiscos.value = 1;
          totalPaginasRiscos.value = 1;
        } else {
          const resp = await store.dispatch("gestaoDeRiscos/listarRiscos", {
            vendorId: unidadeSelecionada.value.id,
            page: pagina,
            perPage: porPaginaRiscos,
          });
          const resultado = resp.data?.result ?? resp.data?.resultado ?? {};
          riscos.value = resultado.data ?? [];
          totalRiscos.value = resultado.total ?? 0;
          paginaRiscos.value = resultado.currentPage ?? pagina;
          totalPaginasRiscos.value =
            Math.ceil(totalRiscos.value / porPaginaRiscos) || 1;
        }
      } catch {
        quasar.notify({
          message: "Erro ao carregar riscos.",
          color: "negative",
          position: "bottom",
        });
      } finally {
        carregandoRiscos.value = false;
      }
    };

    const carregarVinculos = async (pagina = paginaVinculos.value) => {
      if (!unidadeSelecionada.value?.id) return;
      carregandoVinculos.value = true;
      try {
        if (buscaVinculos.value) {
          const busca = buscaVinculos.value.toLowerCase();
          const resp = await store.dispatch(
            "gestaoDeRiscos/listarVinculosRisco",
            {
              vendorId: unidadeSelecionada.value.id,
              controlType: "ca",
              page: 1,
              perPage: 100,
            }
          );
          const todos =
            resp.data?.result?.data ?? resp.data?.resultado?.data ?? [];
          vinculos.value = todos.filter(
            (row) =>
              row.risk?.code?.toLowerCase().includes(busca) ||
              row.risk?.name?.toLowerCase().includes(busca) ||
              String(row.riskControl?.linkedEntity?.code ?? "")
                .toLowerCase()
                .includes(busca)
          );
          totalVinculos.value = vinculos.value.length;
          paginaVinculos.value = 1;
          totalPaginasVinculos.value = 1;
        } else {
          const resp = await store.dispatch(
            "gestaoDeRiscos/listarVinculosRisco",
            {
              vendorId: unidadeSelecionada.value.id,
              controlType: "ca",
              page: pagina,
              perPage: porPaginaVinculos,
            }
          );
          const resultado = resp.data?.result ?? resp.data?.resultado ?? {};
          vinculos.value = resultado.data ?? [];
          totalVinculos.value = resultado.total ?? 0;
          paginaVinculos.value = resultado.currentPage ?? pagina;
          totalPaginasVinculos.value =
            Math.ceil(totalVinculos.value / porPaginaVinculos) || 1;
        }
      } catch {
        quasar.notify({
          message: "Erro ao carregar vínculos.",
          color: "negative",
          position: "bottom",
        });
      } finally {
        carregandoVinculos.value = false;
      }
    };

    const debounceBuscaRiscos = () => {
      clearTimeout(timerBuscaRiscos);
      timerBuscaRiscos = setTimeout(() => {
        paginaRiscos.value = 1;
        carregarRiscos(1);
      }, 400);
    };

    const debounceBuscaVinculos = () => {
      clearTimeout(timerBuscaVinculos);
      timerBuscaVinculos = setTimeout(() => {
        paginaVinculos.value = 1;
        carregarVinculos(1);
      }, 400);
    };

    const abrirModalCriar = () => {
      if (!unidadeSelecionada.value?.id) {
        quasar.notify({
          message: "Selecione uma Unidade antes de criar o risco.",
          color: "warning",
          position: "bottom",
        });
        return;
      }
      showModalCriar.value = true;
    };

    const abrirModalVincular = () => {
      if (!unidadeSelecionada.value?.id) {
        quasar.notify({
          message: "Selecione uma Unidade antes de vincular.",
          color: "warning",
          position: "bottom",
        });
        return;
      }
      showModalVincular.value = true;
    };

    const confirmarDelecao = (risco) => {
      riscoParaDeletar.value = risco;
      showConfirmDelete.value = true;
    };

    const executarDelecao = async (confirmado) => {
      showConfirmDelete.value = false;
      if (!confirmado || !riscoParaDeletar.value) return;

      try {
        await store.dispatch("gestaoDeRiscos/deletarRisco", {
          id: riscoParaDeletar.value.id,
        });
        quasar.notify({
          message: "Risco excluído com sucesso!",
          color: "positive",
          position: "bottom",
          icon: "check_circle",
        });
        carregarRiscos();
      } catch {
        quasar.notify({
          message: "Erro ao excluir risco.",
          color: "negative",
          position: "bottom",
        });
      } finally {
        riscoParaDeletar.value = null;
      }
    };

    const abrirHistorico = async (row) => {
      showModalHistorico.value = true;
      carregandoHistorico.value = true;
      historicoRisco.value = [];
      try {
        const resp = await store.dispatch(
          "gestaoDeRiscos/listarHistoricoRisco",
          {
            riskId: row.id,
            perPage: 100,
          }
        );
        historicoRisco.value =
          resp.data?.result?.data ?? resp.data?.resultado?.data ?? [];
      } catch {
        quasar.notify({
          message: "Erro ao carregar histórico.",
          color: "negative",
          position: "bottom",
        });
      } finally {
        carregandoHistorico.value = false;
      }
    };

    const consultarProdutos = async (row) => {
      const caCode = row.riskControl?.linkedEntity?.code;
      const contractId = store.state.org.contract;
      tituloModalProdutos.value = `Produtos vinculados ao CA ${caCode ?? ""}`;
      showModalProdutos.value = true;
      carregandoModalProdutos.value = true;
      produtosCA.value = [];
      try {
        const resp = await store.dispatch("gestaoDeRiscos/listarProdutosCA", {
          contract_id: contractId,
          ca_code: caCode,
          per_page: 100,
          page: 1,
        });
        produtosCA.value = resp.data?.model?.products?.data ?? [];
      } catch {
        quasar.notify({
          message: "Erro ao carregar produtos.",
          color: "negative",
          position: "bottom",
        });
      } finally {
        carregandoModalProdutos.value = false;
      }
    };

    onMounted(() => {
      if (unidadeSelecionada.value?.id) {
        carregarRiscos(1);
      }
    });

    watch(unidadeSelecionada, (nova, antiga) => {
      if (nova?.id === antiga?.id) return;
      paginaRiscos.value = 1;
      paginaVinculos.value = 1;
      carregarRiscos(1);
      carregarVinculos(1);
    });

    watch(tab, (novaTab) => {
      if (novaTab === "vinculos" && vinculos.value.length === 0) {
        carregarVinculos(1);
      }
    });

    return {
      tab,
      unidadeSelecionada,
      riscos,
      carregandoRiscos,
      buscaRiscos,
      paginaRiscos,
      totalRiscos,
      totalPaginasRiscos,
      vinculos,
      carregandoVinculos,
      buscaVinculos,
      paginaVinculos,
      totalVinculos,
      totalPaginasVinculos,
      showModalCriar,
      showModalVincular,
      showConfirmDelete,
      colunasRiscos,
      colunasVinculos,
      linhaEditando,
      edicao,
      salvandoEdicao,
      iniciarEdicao,
      cancelarEdicao,
      salvarEdicao,
      formatarData,
      carregarRiscos,
      carregarVinculos,
      debounceBuscaRiscos,
      debounceBuscaVinculos,
      abrirModalCriar,
      abrirModalVincular,
      confirmarDelecao,
      executarDelecao,
      consultarProdutos,
      abrirHistorico,
      showModalHistorico,
      historicoRisco,
      carregandoHistorico,
      colunasHistorico,
      showModalProdutos,
      produtosCA,
      carregandoModalProdutos,
      tituloModalProdutos,
      colunasProdutos,
    };
  },
};
</script>
